import Button from "Components/Global/Buttons";

import * as S from "./styles";

const PopUpModal = ({ popUps, read, index }) => {
  if (index === popUps.length) return null;

  return (
    <S.Modal>
      <p>
        {index + 1} / {popUps.length}
      </p>
      <S.Title>
        <h1>{popUps[index].title}</h1>
      </S.Title>

      <p dangerouslySetInnerHTML={{ __html: popUps[index].description }}></p>

      <S.Buttons>
        <Button
          text="OK"
          onClick={() => {
            read(popUps[index].id, "popup");
          }}
          size="sm"
          width="70px"
        />
      </S.Buttons>
    </S.Modal>
  );
};

export default PopUpModal;
